export default __webpack_public_path__ + "static/media/480_dummy2016-restaurant02-mobile-de.399f6eb7.png";